import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {Button, CardHeader, Paper, Table, TableBody, TableCell, TableRow, TextField} from "@mui/material";
import {PopupMessage} from "../../utils/message";

export class RedisPublish extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            channel: "server",
            event: "internal-event",
            action: "sync-files",
            data: "",
        };
    }

    changeStateValue = (key, event) => {
        const value = event.target.value;
        this.setState({[key]: value});
    }

    onPublish = async () => {
        console.log(`publish state: ${JSON.stringify(this.state)} `);

        const url = `${Config.getInstance.apiUrl}/api/publish_redis/`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            channel: this.state.channel,
            event: this.state.event,
            action: this.state.action,
            data: this.state.data,
        };
        
        const response = await axios.post(url, body, {headers});

        if (response.data.success) {
            PopupMessage.success("Published successfully");
        } else {
            PopupMessage.error(`Publish failed: ${response.data.msg}`)
        }
    }

    render() {

        return <div className="contentPadding" style={{width: "100%"}}>
            <Paper className="root" elevation={0}>
                <CardHeader title="Publish Redis" />
                <React.Fragment>
                    <Table className="min-table-size">
                        <TableBody>
                            <TableRow>
                                <TableCell width={"20%"}>Channel:</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.channel}
                                        onChange={this.changeStateValue.bind(this, "channel")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell width={"20%"}>Event:</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.event}
                                        onChange={this.changeStateValue.bind(this, "event")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell width={"20%"}>Action:</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        value={this.state.action}
                                        onChange={this.changeStateValue.bind(this, "action")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell width={"20%"}>Data:</TableCell>
                                <TableCell>
                                    <TextField
                                        style={{backgroundColor: "#505050"}}
                                        fullWidth
                                        id="fullWidth"
                                        placeholder="JSON Data"
                                        value={this.state.data}
                                        onChange={this.changeStateValue.bind(this, "data")}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Button
                                        style={{float: "right"}}
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onPublish.bind(this)}
                                    >
                                        Publish
                                    </Button>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </React.Fragment>
            </Paper>
        </div>
    }
}